module.exports = __webpack_public_path__ + "static/media/Apple iPhone SE Silver.0afe9ea7.png";